import { render } from "./CustomChips.vue?vue&type=template&id=304a5a12"
import script from "./CustomChips.vue?vue&type=script&lang=js"
export * from "./CustomChips.vue?vue&type=script&lang=js"

import "./CustomChips.vue?vue&type=style&index=0&id=304a5a12&lang=css"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\34\\s\\PESVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__